export default "__VITE_ASSET__BY7HoY2a__"